import { FocusStyleManager } from '@blueprintjs/core'
import React from 'react'
import { Provider } from 'react-redux'
import AppError from './components/AppError'
import Router from './router'
import store from './store'
import './style.scss'
import { AmplitudeProvider } from './contexts/AmplitudeContext'

FocusStyleManager.onlyShowFocusOnTabs()

export default () => (
  <AppError>
    <Provider store={store}>
      <AmplitudeProvider>
        <Router />
      </AmplitudeProvider>
    </Provider>
  </AppError>
)
